export default "__VITE_ASSET__BnzOwA84__"